import { forwardRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import classNames from 'classnames'
import { HideIcon, ShowIcon } from 'src/components/icons'

import IconButton from '../iconButton'

import { Input as AntInput, InputProps as AntInputProps, InputRef, theme, Typography } from 'antd'

const { useToken } = theme
const { Text } = Typography

export interface CustomInputProps extends AntInputProps {
    //PasswordProps is already an extension of the InputProps
    title?: string
    errorMessage?: string
    type?: 'default' | 'password'
}

const Input = forwardRef<InputRef, CustomInputProps>((props, ref) => {
    const { title, errorMessage, className, type = 'default', ...restProps } = props
    const { token } = useToken()

    return (
        <div className={`flex w-full flex-col ${className}`}>
            {title && <div className="mb-2">{title}</div>}
            {type === 'password' ? <PasswordInput ref={ref} {...restProps} /> : <AntInput ref={ref} {...restProps} />}
            {errorMessage && <span style={{ color: token.colorError }}>{errorMessage}</span>}
        </div>
    )
})

const PasswordInput = forwardRef<InputRef, CustomInputProps>((props, ref) => {
    const { value, type, readOnly, ...restProps } = props

    const { t } = useTranslation()

    const [showPassword, setShowPassword] = useState(false)

    if (readOnly) {
        const passwordValue = showPassword ? value?.toString() : value?.toString().replace(/./g, '*')
        return (
            <div className="flex items-center justify-between">
                <Text
                    title={passwordValue}
                    className={classNames('w-3/4 overflow-hidden whitespace-nowrap', {
                        'text-ellipsis text-xs': showPassword,
                        'text-sm': !showPassword,
                    })}
                >
                    {passwordValue}
                </Text>
                <IconButton
                    className="p-0"
                    type="text"
                    title={showPassword ? t('Hide password') : t('Show password')}
                    icon={showPassword ? <HideIcon /> : <ShowIcon />}
                    onClick={() => setShowPassword(!showPassword)}
                />
            </div>
        )
    }

    return <AntInput.Password ref={ref} value={value} {...restProps} />
})

export default Input
